import { Colors } from '@prezi/dragon';
import { ButtonTheme } from './Button';

export const disabledTheme: ButtonTheme = {
    fgColor: Colors.neutral300,
    bgColor: Colors.neutral80,
    bgHoverColor: Colors.neutral80,
};

export const darkButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.neutral800,
    bgHoverColor: Colors.neutral800,
};

export const grayButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.gray2,
    bgHoverColor: Colors.gray2,
};

export const lightGrayButtonTheme: ButtonTheme = {
    fgColor: Colors.neutral600,
    bgColor: Colors.neutral80,
    bgHoverColor: Colors.neutral300,
};

export const whiteButtonTheme: ButtonTheme = {
    fgColor: Colors.neutral600,
    bgColor: Colors.white,
    bgHoverColor: Colors.neutral80,
};

export const purpleButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.purple600,
    bgHoverColor: 'rgba(98, 0, 143, 0.72)',
};

export const blueButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.blue500,
    bgHoverColor: Colors.blue600,
};

export const redButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.red500,
    bgHoverColor: Colors.red600,
};

export const goldButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.gold,
    bgHoverColor: 'rgba(223, 171, 41, 0.8)',
};

export const orangeButtonTheme: ButtonTheme = {
    fgColor: Colors.white,
    bgColor: Colors.orange,
    bgHoverColor: '#FF6F26',
};

export enum Themes {
    DARK = 'dark',
    GRAY = 'gray',
    LIGHT = 'light',
    WHITE = 'white',
    PURPLE = 'purple',
    BLUE = 'blue',
    GOLD = 'gold',
    ORANGE = 'orange',
    DISABLED = 'disabled',
}

export type ThemeName =
    | 'dark'
    | 'gray'
    | 'light'
    | 'white'
    | 'purple'
    | 'blue'
    | 'red'
    | 'gold'
    | 'orange'
    | 'disabled';

const THEME_MAP = {
    dark: darkButtonTheme,
    gray: grayButtonTheme,
    light: lightGrayButtonTheme,
    white: whiteButtonTheme,
    purple: purpleButtonTheme,
    blue: blueButtonTheme,
    red: redButtonTheme,
    gold: goldButtonTheme,
    orange: orangeButtonTheme,
    disabled: disabledTheme,
};

export const getTheme = (themeName: ThemeName) => THEME_MAP[themeName];
